module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2318893.d78fbcc1.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2318893.pdf
// module id = 849
// module chunks = 0